import { render, staticRenderFns } from "./NumberOptions.vue?vue&type=template&id=c48dc4e8&"
import script from "./NumberOptions.vue?vue&type=script&lang=js&"
export * from "./NumberOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports